export default "<a class=\"{{logoClass}}\" routerLink=\"/home\">\n\t<img src=\"assets/images/logo-white.png\" width=\"200\"  alt=\"logo\">\n</a>"